import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'relativeDate',
  standalone: false,
  pure: true,
})
export class RelativeDatePipe implements PipeTransform {
  transform(value: Date | string | number | null | undefined): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return '';
    }

    const now = new Date();

    const diffMs = now.getTime() - date.getTime();
    const isFuture = diffMs < 0;
    const diff = Math.abs(diffMs);

    const minute = 60 * 1000;
    const hour = 60 * minute;
    const day = 24 * hour;
    const week = 7 * day;

    // Future dates
    if (isFuture) {
      if (diff < minute) {
        return 'in a moment';
      }

      if (diff < hour) {
        return `in ${Math.floor(diff / minute)}m`;
      }

      if (diff < day) {
        return `in ${Math.floor(diff / hour)}h`;
      }

      if (this.isToday(date, now)) {
        return 'today';
      }

      if (this.isTomorrow(date, now)) {
        return 'tomorrow';
      }

      if (diff < week) {
        return `in ${Math.floor(diff / day)}d`;
      }

      if (diff < 30 * day) {
        return `in ${Math.floor(diff / week)}w`;
      }

      if (diff < 365 * day) {
        return `in ${Math.floor(diff / (30 * day))}mo`;
      }

      return `in ${Math.floor(diff / (365 * day))}y`;
    }

    // Past dates
    if (diff < minute) {
      return 'just now';
    }

    if (diff < hour) {
      return `${Math.floor(diff / minute)}m`;
    }

    if (diff < day) {
      return `${Math.floor(diff / hour)}h`;
    }

    if (this.isToday(date, now)) {
      return 'today';
    }

    if (this.isYesterday(date, now)) {
      return 'yesterday';
    }

    if (diff < week) {
      return `${Math.floor(diff / day)}d`;
    }

    if (diff < 30 * day) {
      return `${Math.floor(diff / week)}w`;
    }

    if (diff < 365 * day) {
      return `${Math.floor(diff / (30 * day))}mo`;
    }

    return `${Math.floor(diff / (365 * day))}y`;
  }

  private isToday(date: Date, now: Date): boolean {
    return (
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate()
    );
  }

  private isYesterday(date: Date, now: Date): boolean {
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    return (
      date.getFullYear() === yesterday.getFullYear() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getDate() === yesterday.getDate()
    );
  }

  private isTomorrow(date: Date, now: Date): boolean {
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);

    return (
      date.getFullYear() === tomorrow.getFullYear() &&
      date.getMonth() === tomorrow.getMonth() &&
      date.getDate() === tomorrow.getDate()
    );
  }
}